module.exports = __webpack_public_path__ + "media/assets/img/logo/logo-dd389142badaff129eac3602eef14882.png";